export const CONFIG_REQUEST = "CONFIG_REQUEST";
export const CONFIG_SUCCESS = "CONFIG_SUCCESS";
export const CONFIG_FAIL = "CONFIG_FAIL";
export const CONFIG_CLEAR_ERRORS = "CONFIG_CLEAR_ERRORS";
